<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <!-- <div class="weui-cell" slot="pi_class">
          <div class="weui-cell__hd">
            <label for class="weui-label">单据类型</label>
          </div>
          <div class="weui-cell__bd">{{ '库存初始化' }}</div>
        </div> -->
        <month-field
          slot="pwd_ym"
          :label="customLabel.pwd_ym || '调整账期'"
          v-model="form.main.pwd_ym"
        />
      </custom-layout>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>物料{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <product-field
              slot="pr_detail"
              :label="customLabel.pr_detail || '物料名称'"
              v-model="item.pr_detail"
              @select="onSelectProduct($event, item)"
            />
            <div class="weui-cell" slot="pwd_whname" v-if="item.pwd_whname">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  '仓库'
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{item.pwd_whname}}
              </div>
            </div>
            <!-- <warehouse-field
              slot="pwd_whname"
              v-model="item.pwd_whname"
              @select="onSelectWarehouse($event, item)"
              :label="customLabel.pwd_whname || '仓库'"
            /> -->
            <div class="weui-cell" slot="pwd_amount">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  '调整金额'
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.pwd_amount"
                  placeholder="0"
                />
              </div>
            </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import MonthField from "@/components/field/MonthField.vue";
// import WarehouseField from "@/components/field/WarehouseField.vue";
import ProductField from "@/components/field/ProductField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    MonthField,
    // WarehouseField,
    ProductField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/storage/productwhmonthadjust",
      codeField: "pwa_code",
      statusField: "pwa_statuscode",
      caller: "ProductWhMonthAdjust",
      xtype: "stock-productwhmonthadjust-formpanel",
      form: {
        main: {

        },
        items: [
          {

          },
        ],
      }
    };
  },
  methods: {
    onSelectProduct(selection, item) {
      item.pr_detail = selection.pr_detail;
      item.pr_code = selection.pr_code;
      item.pr_brand = selection.pr_brand;
      item.pr_kind = selection.pr_kind;
      item.pr_unit = selection.pr_unit;

      item.pwd_prodid = selection.id
      item.pwd_prodcode = selection.pr_code

      item.pwd_whid = selection.pr_whid;
      item.pwd_whcode = selection.pr_whcode;
      item.pwd_whname = selection.pr_whname;
    },
    /**
     * 选择仓库
     */
    // onSelectWarehouse(selection, item) {
    //   item.pwd_whid = selection.id;
    //   item.pwd_whcode = selection.wh_code;
    // },
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({

      });
    },
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.pwa_ym) {
        me.$weui.topTips("请选择日期", 2000);
      } else {
        var count = 0;
        items.forEach(function (item) {
          if (!item.pwd_whname) {
            me.$weui.topTips(`第${count + 1}行仓库未选择`, 2000);
            return false;
          } else if (!item.pr_detail) {
            me.$weui.topTips(`第${count + 1}行物料未选择`, 2000);
            return false;
          } else if (!item.pwd_amount) {
            me.$weui.topTips(`第${count + 1}行调整金额未填写`, 2000);
            return false;
          } else {
            count++;
            item.pwd_detno = count
          }
        });
        checked = count == items.length;
      }

      if (checked) {
        me.p_save();
      }
    },
  },
};
</script>